// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jC4Aa","left":"styles_left__2e3BX","desktopActions":"styles_desktopActions__2KZ2-","title":"styles_title__2c2sn"};